import { Button } from '@mui/material'

import { IonInformationModal } from '@/components/organisms/functionals'
import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

/**
 * @description
 * チケット購入後に表示するモーダル
 */
export const CompleteTicketChargeModal: Organism<{
  open: boolean
  onClose: () => void
}> = ({ open, onClose }) => {
  const { t } = useTranslation('gachaDetail')
  return (
    <IonInformationModal
      open={open}
      onClose={onClose}
      title={t('purchaseCompleteTitle')}
      content={t('purchaseCompleteDesc')}
      buttons={
        <Button
          sx={{ minWidth: 212 }}
          variant="contained"
          color="primary"
          size="large"
          onClick={onClose}
        >
          {t('ok')}
        </Button>
      }
    />
  )
}
